export default __webpack_public_path__ + "static/media/vp2.ad1e06f9.jpg";